<template>
  <div>
    <v-autocomplete
      :value="selected"
      @input="select"
      :items="items"
      :label="label"
      :filter="filter"
      :no-data-text="lang.items.datatable.no_results"
      item-text="title"
      item-value="id"
      :return-object="returnObject"
      :clearable="clearable"
      :single-line="singleLine"
      clear-icon="mdi-broom"
      prepend-inner-icon="mdi-plus-thick"
      autocomplete="off"
      :class="{ 'itemsAutoComp': true, 'hide-chips': hideChips, 'single-line': singleLine }"
      filled
      chips
      multiple
      hide-details
    >
      <template v-slot:selection="{ item, selected }">
        <v-chip
          v-if="!hideChips"
          :input-value="selected"
          close
          class="chip--select-multi"
          @click:close="remove(item)"
        >
          <Thumb
            v-if="item.photo"
            :photo="item.photo"
            :size="20"
            class="mr-2"
          />
          {{ item.title }}
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-avatar>
          <Thumb
            :photo="item.photo"
            :size="40"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ `${(item.cod.trim() ? '#' + item.cod.trim() + ' - ' : '')}${item.title}` }}
            <span class="price">{{ formatCurrency(item.price) }}</span>
          </v-list-item-title>
          <v-list-item-subtitle>{{ (item.cat ? item.cat_name : lang.categories.new.no_cat) }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Thumb from '@/components/catalog/items/templates/Thumb'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Thumb },
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    label: {
      type: String,
      default: null
    },
    hideChips: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    isOrder: {
      type: Boolean,
      default: false
    },
    singleLine: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: (this.value ? [ ...this.value ] : [])
    }
  },
  computed: {
    items: {
      get () {
        let items = Object.values(this.get_data.catalog)
        let group = items.reduce((r, a) => {
          r[a.parent_cat] = [...r[a.parent_cat] || [], a]
          return r
        }, [])
        const flatten = group.reduce((add, val) => add.concat(val), [])
        const orderAssign = (price) => ({
          qty: 1,
          total: price,
          adt: [],
          obs: ''
        })
        let result = []
        var currentCat = null
        flatten.forEach((value) => {
          if (currentCat !== value.parent_cat) result.push({ header: (value.parent_cat === 0 ? this.lang.categories.new.no_cat : value.parent_cat_name) })
          // ADD ORDER DEFAULTS
          value = (this.isOrder ? Object.assign({ ...value }, { ...orderAssign(value.price) }) : value)
          currentCat = value.parent_cat
          result.push({ ...value })
        })
        console.log('items out ', result)
        return [ ...result ]
      },
      set () {
        /* */
      }
    }
  },
  watch: {
    selected: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.value) !== JSON.stringify(newVal)) this.$emit('input', [ ...this.selected ])
      }
    },
    value: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.selected) !== JSON.stringify(newVal)) this.selected = [ ...this.value ]
      }
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    filter (item, queryText, itemText) {
      if (typeof item.header === 'undefined' && queryText) {
        console.log('item', item)
        console.log('queryText', queryText)
        return (
          (item.title.toLowerCase().trim().search(queryText.toLowerCase()) > -1) ||
          (this.formatCurrency(item.price).toLowerCase().trim().search(String(queryText)) > -1) ||
          (item.cat_name.toLowerCase().trim().search(queryText.toLowerCase()) > -1) ||
          (item.parent_cat_name.toLowerCase().trim().search(queryText.toLowerCase()) > -1)
        )
      }
    },
    select (items) {
      this.$set(this, 'selected', [ ...items ])
    },
    remove (item) {
      const obj = (this.returnObject ? this.selected.find(el => el.id === item.id) : this.selected.find(el => el === item.id))
      const index = this.selected.indexOf(obj)
      if (index >= 0) this.selected.splice(index, 1)
    }
  }
}
</script>

<style scoped src="../styles/autocomplete.css"></style>
